<script>
export const FEATURES = {
  is_suitable_probe: {
    textValid:
      "The target has chemical probes that meet the minimum quality criteria",
    textInvalid:
      "The target has not a chemical probe that meets the minimum quality criteria",
    textValidCompound: "The compound meets the minimum quality criteria",
    textInvalidCompound:
      "The compound does not meet the minimum quality criteria",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/MINQUALITY-ON.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/MINQUALITY-OFF.png",
  },
  is_selectivity: {
    textValid:
      "The target has chemical probes that are 10-fold selective against any other protein",
    textInvalid:
      "The target has not chemical probes that are 10-fold selective against any other protein",
    textValidCompound:
      "The compound is 10-fold selective against any other protein",
    textInvalidCompound:
      "The compound is not 10-fold selective against any other protein",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/SELECTIVE-ON.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/SELECTIVE-OFF.png",
  },
  is_target_potency: {
    textValid: "The target has chemical probes that are potent (<100 nM)",
    textInvalid: "The target has not chemical probes that are potent (<100 nM)",
    textValidCompound: "The compound is potent (<100 nM)",
    textInvalidCompound: "The compound is not potent (<100 nM)",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/BIOCHEMPOTENT-ON.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/BIOCHEMPOTENT-OFF.png",
  },
  is_cell_potency: {
    textValid: "The target has chemical probes that are cell-active (<10 uM)",
    textInvalid:
      "The target has not chemical probes that are cell-active (<10 uM)",
    textValidCompound: "The compound is cell-active (<10 uM)",
    textInvalidCompound: "The compound is not cell-active (<10 uM)",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/CELLACTIVE-ON.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/CELLACTIVE-OFF.png",
  },
  is_sar: {
    textValid:
      "The target has chemical probes with Structure-Activity Relationships (SAR)",
    textInvalid:
      "The target has not chemical probes with Structure-Activity Relationships (SAR)",
    textValidCompound:
      "The compound has Structure-Activity Relationships (SAR)",
    textInvalidCompound:
      "The compound has not Structure-Activity Relationships (SAR)",
    imageValid:
      process.env.API_URL + "shared/resources/images/chemprobes/SAR-ON.png",
    imageInvalid:
      process.env.API_URL + "shared/resources/images/chemprobes/SAR-OFF.png",
  },
  is_inactive_analogs: {
    textValid: "The target has chemical probes which have inactive analogs",
    textInvalid:
      "The target has not chemical probes which have inactive analogs",
    textValidCompound: "The compound has inactive analogs",
    textInvalidCompound: "The compound has not inactive analogs",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/INACTIVE-ANALOG-ON.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/INACTIVE-ANALOG-OFF.png",
  },
  is_pains: {
    textValid:
      "The target has chemical probes which are not a Pan-Assay Interfering Compound (PAINS)",
    textInvalid:
      "The target has not chemical probes which are not a Pan-Assay Interfering Compound (PAINS)",
    textValidCompound:
      "The compound is not a Pan-Assay Interfering Compound (PAINS)",
    textInvalidCompound:
      "The compound is a Pan-Assay Interfering Compound (PAINS)",
    imageValid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/NON-PAINS-GREEN.png",
    imageInvalid:
      process.env.API_URL +
      "shared/resources/images/chemprobes/PAINS-GREY-RED.png",
  },
};
</script>



// WEBPACK FOOTER //
// Features.vue?769c412e